import { createContext, useContext } from 'react';
import AuthStore from './AuthStore/AuthStore';
import RootStore from './RootStore/RootStore';
import DashboardStore from './Dashboard/DashboardStore';
import AdminUsersStore from './AdminUserStore';
import AdmnSettingsStore from './AdminSettingsStore';
import MerchantStore from './MerchantStore';
import TempleStore from './TempleStore';
import BulkFileTempleStore from './BulkImport/TempleImport';
import BulkFileAccommodationStore from './BulkImport/AccommodationImport';
import AccommodationStore from './AccommodationStore';
import RegionStore from './RegionStore';
import PublicSettingsStore from './PublicSettingsStore';
import PaymentStore from './PaymentStore';
import BookingInvoiceStore from './BookingInvoiceStore';
import CustomerStore from './CustomerStore';
import EnquiryStore from './EnquiryStore';

const AppContext = createContext({
	ROOT: new RootStore(),
	AUTH: new AuthStore(),
	DASHBOARD: new DashboardStore(),
	TEMPLE: new TempleStore(),
	ADMINUSER: new AdminUsersStore(),
	ADMINSETTINGS: new AdmnSettingsStore(),
	MERCHANT: new MerchantStore(),
	BULKTEMPLE: new BulkFileTempleStore(),
	BULKACCOMMODATION: new BulkFileAccommodationStore(),
	ACCOMMODATION: new AccommodationStore(),
	REGION: new RegionStore(),
	PUBLICSETTINGS: new PublicSettingsStore(),
	PAYMENT: new PaymentStore(),
	BOOKINGINVOICE: new BookingInvoiceStore(),
	CUSTOMER: new CustomerStore(),
	ENQUIRY: new EnquiryStore()
});

const useStore = () => useContext(AppContext);

export default useStore;
